<template>
  <!-- preloader -->
    <div class="loader-wrap">
        <div class="preloader">
            <div class="preloader-close">Preloader Close</div>
            <div id="handle-preloader" class="handle-preloader">
                <div class="animation-preloader">
                    <div class="spinner"></div>
                    <div class="txt-loading">
                        <span data-text-preloader="a" class="letters-loading">
                            a
                        </span>
                        <span data-text-preloader="k" class="letters-loading">
                            k
                        </span>
                        <span data-text-preloader="s" class="letters-loading">
                            s
                        </span>
                        <span data-text-preloader="h" class="letters-loading">
                            h
                        </span>
                        <span data-text-preloader="a" class="letters-loading">
                            a
                        </span>
                        <span data-text-preloader="r" class="letters-loading">
                            r
                        </span>
                    </div>
                </div>  
            </div>
        </div>
    </div>
  <!-- preloader end -->

  <!-- main header -->
    <header :class="['main-header', { 'header-style-two': route.name === 'home' }]">
        <!-- header-lower -->
        <div class="header-lower">
            <div
                v-if="route.name !== 'home'"
                class="shape"
                style="background-image: url(assets/images/shape/shape-1.png);"
            ></div>
            <div class="outer-box">
                <div class="logo-box">
                    <figure class="logo"><router-link to="/"><img src="/assets/images/logo/logo-5.png" alt="logo"></router-link></figure>
                </div>
                <div class="menu-area clearfix">
                    <!--Mobile Navigation Toggler-->
                    <div class="mobile-nav-toggler">
                        <i class="icon-bar"></i>
                        <i class="icon-bar"></i>
                        <i class="icon-bar"></i>
                    </div>
                    <nav class="main-menu navbar-expand-md navbar-light">
                        <div class="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
                            <ul class="navigation clearfix">
                                <li :class="{ 'current': route.name === 'home' }"><router-link to="/">Home</router-link></li>
                                <li :class="{ 'current': route.name === 'about-us' }"><router-link to="/about-us">About Us</router-link></li>
                                <li :class="{ 'current': route.name === 'product' }"><router-link to="/product">Products</router-link></li>
                                <li :class="{ 'current': route.name === 'contact-us' }"><router-link to="/contact-us">Contact</router-link></li>
                            </ul>
                        </div>
                    </nav>
                </div>
                <ul class="nav-right">
                    <li class="btn-box">
                        <button @click="downloadPDF" class="theme-btn btn-one">Download Brochure</button>
                    </li>
                </ul>
            </div>
        </div>

        <!--sticky Header-->
        <div class="sticky-header">
            <div class="outer-box">
                <div class="logo-box">
                    <figure class="logo"><a href="/"><img src="/assets/images/logo/logo-1.png" alt="logo"></a></figure>
                </div>
                <div class="menu-area clearfix">
                    <nav class="main-menu clearfix">
                        <!--Keep This Empty / Menu will come through Javascript-->
                    </nav>
                </div>
                <ul class="nav-right">
                    <li class="btn-box">
                        <button @click="downloadPDF" class="theme-btn btn-one">Download Brochure</button>
                    </li>
                </ul>
            </div>
        </div>
    </header>
    <!-- main-header end -->

    <!-- Mobile Menu  -->
    <div class="mobile-menu">
        <div class="menu-backdrop"></div>
        <div class="close-btn"><i class="fas fa-times"></i></div>
        
        <nav class="menu-box">
            <div class="nav-logo"><router-link to="/"><img src="/assets/images/logo-2.png" alt="logo" title="logo"></router-link></div>
            <div class="menu-outer"><!--Here Menu Will Come Automatically Via Javascript / Same Menu as in Header--></div>
            <div class="contact-info">
                <h4>Contact Info</h4>
                <ul>
                    <li>C-1401, Shilpan Prime, 80 feet Punit Nagar Road, Mavdi, Rajkot 360005</li>
                    <li><a href="tel:+919726467383">+(91) 97264 67383</a></li>
                    <li><a href="mailto:info@aksharwatertech.in">info@aksharwatertech.in</a></li>
                </ul>
            </div>
            <div class="social-links">
                <ul class="clearfix">
                    <li><a href="#"><span class="fab fa-facebook-square"></span></a></li>
                    <li><a href="#"><span class="fab fa-instagram"></span></a></li>
                    <li><a href="#"><span class="fab fa-linkedin-in"></span></a></li>
                </ul>
            </div>
        </nav>
    </div><!-- End Mobile Menu -->

</template>
<script setup>
import { useRoute } from 'vue-router'
const route = useRoute()

function downloadPDF() {
  const pdfUrl = '/assets/broucher/AKSHAR WATERTECH CATALOG FINAL.pdf' // can also be from API
  const link = document.createElement('a')
  link.href = pdfUrl
  link.download = 'AKSHAR WATERTECH CATALOG.pdf'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
</script>
